import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { IdDocImageSide } from '@/idv2/features/collect-document/types';
import type { ReceivedImagePayload } from '../../../types';
import { isFront, isSelfie } from '../../../utils/capture';
import { useIdDocMachine } from '../../context/id-doc-context';
import docTypeTranslationKeyMap from '../../utils/doc-type-translation-key-map';
import MobileFallbackUploadView from './mobile-fallback-upload-view';
export { FlexColumnMotionContainer } from './mobile-fallback-upload-view';
type MobileFallbackUploadProps = {
  imageType: `${IdDocImageSide}`;
};
const MobileFallbackUpload = t0 => {
  const $ = _c(25);
  const {
    imageType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.id-doc.pages"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const [state, dispatch] = useIdDocMachine();
  const {
    hasBadConnectivity,
    idDoc,
    allowPdf,
    requirement
  } = state.context;
  const allowUpload = requirement.uploadSettings !== "capture_only_on_mobile" && requirement.uploadSettings !== "require_mobile_capture";
  let t2;
  if ($[1] !== imageType || $[2] !== t) {
    t2 = () => {
      if (isSelfie(imageType)) {
        return t(_temp);
      }
      if (isFront(imageType)) {
        return t(_temp2);
      }
      return t(_temp3);
    };
    $[1] = imageType;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getTitle = t2;
  let t3;
  if ($[4] !== idDoc || $[5] !== imageType || $[6] !== t) {
    t3 = () => {
      if (isSelfie(imageType)) {
        return t(_temp4);
      }
      if (!idDoc.type) {
        return null;
      }
      const lastKey = docTypeTranslationKeyMap[idDoc.type as keyof typeof docTypeTranslationKeyMap];
      if (!lastKey) {
        return null;
      }
      if (isFront(imageType)) {
        return t($_3 => $_3["mobile-front-photo-fallback-upload"].subtitle[lastKey as keyof (typeof $_3)['mobile-front-photo-fallback-upload']['subtitle']]);
      }
      return t($_4 => $_4["mobile-back-photo-fallback-upload"].subtitle[lastKey as keyof (typeof $_4)['mobile-back-photo-fallback-upload']['subtitle']]);
    };
    $[4] = idDoc;
    $[5] = imageType;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getSubtitle = t3;
  let t4;
  if ($[8] !== getTitle) {
    t4 = getTitle();
    $[8] = getTitle;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const title = t4;
  let t5;
  if ($[10] !== getSubtitle) {
    t5 = getSubtitle();
    $[10] = getSubtitle;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const subtitle = t5;
  if (!subtitle) {
    return null;
  }
  let t6;
  if ($[12] !== dispatch) {
    t6 = () => dispatch({
      type: "navigatedToPrev"
    });
    $[12] = dispatch;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleBack = t6;
  let t7;
  if ($[14] !== dispatch) {
    t7 = payload => dispatch({
      type: "receivedImage",
      payload
    });
    $[14] = dispatch;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const handleComplete = t7;
  let t8;
  if ($[16] !== allowPdf || $[17] !== allowUpload || $[18] !== handleBack || $[19] !== handleComplete || $[20] !== hasBadConnectivity || $[21] !== imageType || $[22] !== subtitle || $[23] !== title) {
    t8 = <MobileFallbackUploadView imageType={imageType} title={title} subtitle={subtitle} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} allowUpload={allowUpload} onBack={handleBack} onComplete={handleComplete} />;
    $[16] = allowPdf;
    $[17] = allowUpload;
    $[18] = handleBack;
    $[19] = handleComplete;
    $[20] = hasBadConnectivity;
    $[21] = imageType;
    $[22] = subtitle;
    $[23] = title;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};
export default MobileFallbackUpload;
function _temp($) {
  return $["mobile-selfie-fallback-upload"].title;
}
function _temp2($_0) {
  return $_0["mobile-front-photo-fallback-upload"].title;
}
function _temp3($_1) {
  return $_1["mobile-back-photo-fallback-upload"].title;
}
function _temp4($_2) {
  return $_2["mobile-selfie-fallback-upload"].subtitle;
}